// ----------------------------------------------------------------------
import styles from '../styles.module.css';
import { useEffect, useState } from 'react';
import TextField from '@mui/material/TextField';
import { Card, Avatar } from '@mui/material';
import Scrollbar from '../../../components/scrollbar';
import { useNavigate } from 'react-router-dom';
// sections
// mock
import { useLayoutEffect } from 'react';
import GlobalModal from 'src/Modals/GlobalModal';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { createRef } from 'react';
import { Box } from '@mui/material';
import Fade from '@mui/material/Fade';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import axiosInstance from 'src/axiosInstance';
import toast from 'react-hot-toast';
import moment from 'moment';
import { BallTriangle } from 'react-loader-spinner';
import CircularProgress from '@mui/material/CircularProgress';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Slide from '@mui/material/Slide';
import { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import DateFormat from 'src/hooks/useDateFormat';
import LiveLocation from 'src/pages/LiveLocation';
import { downloadFile3 } from 'src/utils';
import { Pagination } from 'src/components';
import InputAdornment from '@mui/material/InputAdornment';
import ImageUploader from 'src/components/image-uploader/ImageUploader';
import { useAuth } from 'src/hooks/useAuth';

// ----------------------------------------------------------------------

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 500,
  bgcolor: '#F5F5F5',
  border: '1px solid #F5F5F5',
  borderRadius: '5px',
  boxShadow: 24,
  p: 3,
};

export default function Referrals() {
  const { data } = useAuth();
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [vouchersData, setVouchersData] = useState([]);
  const [currentData, setCurrentData] = useState({});
  const [isPending, setIsPending] = useState(false);
  const [loadingState, setLoadingState] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [currentParticipant, setCurrentParticipant] = useState(false);
  const [viewCurrentVoucher, setViewCurrentVoucher] = useState(false);
  const [dataPagination, setDataPagination] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const notify = (msg) => toast.success(msg);
  const notifyError = (err) => toast.error(err);
  const [createVoucherModalOpen, setCreateVoucherModalOpen] = useState(false);
  const [viewVoucherModalOpen, setViewVoucherModalOpen] = useState(false);
  const [selectedVoucher, setSelectedVoucher] = useState(null);
  const [viewVoucherLoading, setViewVoucherLoading] = useState(false);
  const [editVoucherModalOpen, setEditVoucherModalOpen] = useState(false);
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [deleteVoucherLoading, setDeleteVoucherLoading] = useState(false);
  const [editVoucher, setEditVoucher] = useState({
    voucher_type: 'amount_off',
    amount: '',
    percentage: '',
    medium: ['sms', 'email'],
    start_date: null,
    end_date: null,
    description: '',
    maximum_amount: '',
    maximum_amount_per_user: '',
    target_users: 'new_shopper',
  });
  const [editVoucherLoading, setEditVoucherLoading] = useState(false);
  const [newVoucher, setNewVoucher] = useState({
    banner: null,
    voucher_type: 'percentage_off', // Changed default to percentage_off
    amount: '',
    percentage: '',
    medium: ['email', 'sms'], // Updated to match UI labels
    start_date: null,
    end_date: null,
    maximum_amount: '',
    maximum_amount_per_user: '',
    minimum_order_amount: '', // New field
    target_users: 'new_shopper',
    description: '',
    input_code: '', // NEW FIELD
    discount_occurence: '', // NEW FIELD
    product: '', // for selected_audience
    customer_type: '', // for selected_audience
  });
  const [showMaxAmount, setShowMaxAmount] = useState(false);
  const [showMinOrderAndMaxDiscount, setShowMinOrderAndMaxDiscount] = useState(false);
  const [showMinAmountForAmountOff, setShowMinAmountForAmountOff] = useState(false);

  const [filter, setFilter] = useState({
    search: '',
    target_users: '',
    voucher_type: '',
    start_date_from: '',
    start_date_to: '',
    end_date_from: ''
  });

  // Fetch vouchers on component mount
  useEffect(() => {
    fetchVouchers();
  }, []);

  // Fetch vouchers when filters or pagination changes
  useEffect(() => {
    fetchVouchers();
  }, [currentPage, filter.search, filter.target_users, filter.voucher_type]);
  const handleFilterChange = (key, value) => {
    setFilter((prev) => {
      return {
        ...prev,
        [key]: value,
      };
    });
  };

  const handleCloseFilter = () => {
    setFilterModalOpen(false);
  };

  const handleCreateVoucherChange = (e) => {
    setNewVoucher({ ...newVoucher, [e.target.name]: e.target.value });
  };

  const handleBannerUpload = (file) => {
    setNewVoucher({ ...newVoucher, banner: file });
  };

  const handleStartDateChange = (date) => {
    setNewVoucher({ ...newVoucher, start_date: date });
  };
  const handleExpiryDateChange = (date) => {
    setNewVoucher({ ...newVoucher, end_date: date });
  };

  const handleCreateVoucher = async (e) => {
    e.preventDefault();
    setIsPending(true);
    try {
      const adminId = data?._id || data?.id;
      const payload = {
        input_code: newVoucher.input_code || '',
        start_date: newVoucher.start_date,
        end_date: newVoucher.end_date,
        discount_occurence: Number(newVoucher.discount_occurence) || 1,
        selected_audience: {
          customer_type: newVoucher.target_users,
        },
        voucher_type: newVoucher.voucher_type,
        medium: newVoucher.medium, 
        description: newVoucher.description, 
        updated_by: adminId, 
      };
      
      // Add amount or percentage based on voucher type
      if (newVoucher.voucher_type === 'amount_off') {
        payload.amount = Number(newVoucher.amount);
      } else if (newVoucher.voucher_type === 'percentage_off') {
        payload.percentage = Number(newVoucher.percentage);
      }
      
      // Add minimum order amount and maximum discount per user if provided
      if (newVoucher.minimum_order_amount) {
        payload.minimum_order_amount = Number(newVoucher.minimum_order_amount);
      } else if (newVoucher.voucher_type === 'percentage_off') {
        // Set default minimum order amount for percentage vouchers if not provided
        payload.minimum_order_amount = 1;
      } else if (newVoucher.voucher_type === 'amount_off') {
        // Set default minimum order amount for amount vouchers if not provided
        payload.minimum_order_amount = 1;
      }
      
      if (newVoucher.maximum_amount) {
        payload.maximum_amount = Number(newVoucher.maximum_amount);
      } else if (newVoucher.voucher_type === 'percentage_off') {
        // Set default maximum amount for percentage vouchers if not provided
        payload.maximum_amount = 10000;
      } else if (newVoucher.voucher_type === 'amount_off') {
        // Set default maximum amount for amount vouchers if not provided
        payload.maximum_amount = 10000;
      }
      
      // Only add maximum_amount_per_user for percentage vouchers
      if (newVoucher.voucher_type === 'percentage_off') {
        if (newVoucher.maximum_amount_per_user) {
          payload.maximum_amount_per_user = Number(newVoucher.maximum_amount_per_user);
        } else {
          // Set default maximum amount per user for percentage vouchers if not provided
          payload.maximum_amount_per_user = 1000;
        }
      }
      
      if (newVoucher.product) {
        payload.selected_audience.product = [newVoucher.product];
      }
      
      console.log('Voucher creation payload:', payload);
      const response = await axiosInstance.post('/admin/voucher/create', payload);
      if (response.status < 300) {
        notify('Voucher created successfully!');
    setCreateVoucherModalOpen(false);
        setNewVoucher({
          banner: null,
          voucher_type: 'percentage_off',
          amount: '',
          percentage: '',
          medium: ['email', 'sms'],
          start_date: null,
          end_date: null,
          maximum_amount: '',
          maximum_amount_per_user: '',
          minimum_order_amount: '',
          target_users: 'new_shopper',
          description: '',
          input_code: '',
          discount_occurence: '',
          product: '',
          customer_type: '',
        });
        setShowMaxAmount(false);
        setShowMinOrderAndMaxDiscount(false);
        setShowMinAmountForAmountOff(false);
        fetchVouchers();
      }
    } catch (error) {
      console.error('Error creating voucher:', error);
      const errorMessage = error.response?.data?.message || 'Failed to create voucher. Please try again.';
      notifyError(errorMessage);
    } finally {
      setIsPending(false);
    }
  };

  const processLocation = (e) => {
    handleFilterChange('location', e.formatted_address);
    handleFilterChange('latitude', e.lat);
    handleFilterChange('longitude', e.lng);
  };

  const handleSubmitFilter = () => {
    handleCloseFilter();
    // setSubmitFilter(!submitFilter)
  };

  const handleDownloadFile = async (extension) => {
    setExportLoading(true);
    try {
      const result = `/admin/customers/get-storeowners?page=${dataPagination.currentPage}&perpage=${dataPagination.total}&export_type=${extension}`;
      await downloadFile3('Customer - Stores', result, extension);
    } catch (err) {
      notifyError(err.message);
    } finally {
      setExportLoading(false);
    }
  };

  const fetchVouchers = async () => {
    setIsPending(true);
    try {
      const params = {
          page: currentPage,
          perpage: itemsPerPage,
      };
      
      if (filter.search) params.search = filter.search;
      if (startDate) params.dateFrom = startDate.toISOString().split('T')[0];
      if (endDate) params.dateTo = endDate.toISOString().split('T')[0];
      if (filter.target_users) params.target_users = filter.target_users;
      if (filter.voucher_type) params.voucher_type = filter.voucher_type;
      if (filter.start_date_from) params.start_date_from = filter.start_date_from;
      if (filter.start_date_to) params.start_date_to = filter.start_date_to;
      if (filter.end_date_from) params.end_date_from = filter.end_date_from;

      const response = await axiosInstance.get('/admin/voucher', { params });
      
      if (response.status < 300) {
        setVouchersData(response.data.data?.data || []);
        setDataPagination(response.data.data?.pagination || {});
      }
    } catch (error) {
      console.error('Error fetching vouchers:', error);
      notifyError('Failed to fetch vouchers');
    } finally {
      setIsPending(false);
    }
  };

  const fetchData = () => {
    fetchVouchers();
  };

  const handleViewCurrentParticipant = () => {};

  function handleClick(event) {
    event.preventDefault();
    navigate('/app/promotions');
  }

  const handleViewVoucher = async (voucher) => {
    setViewVoucherModalOpen(true);
    setViewVoucherLoading(true);
    try {
      const response = await axiosInstance.get(`/admin/voucher/${voucher._id}`);
      if (response.status < 300) {
        setSelectedVoucher(response.data.data);
      } else {
        notifyError('Failed to fetch voucher details');
      }
    } catch (error) {
      console.error('Error fetching voucher details:', error);
      notifyError('Failed to fetch voucher details');
    } finally {
      setViewVoucherLoading(false);
    }
  };

  const handleEditVoucher = (voucher) => {
    setEditVoucher({
      voucher_type: voucher.amount ? 'amount_off' : 'percentage_off',
      amount: voucher.amount || '',
      percentage: voucher.percentage || '',
      medium: voucher.medium || ['sms', 'email'],
      start_date: voucher.start_date ? new Date(voucher.start_date) : null,
      end_date: voucher.end_date ? new Date(voucher.end_date) : null,
      description: voucher.description || '',
      maximum_amount: voucher.maximum_amount || '',
      maximum_amount_per_user: voucher.maximum_amount_per_user || '',
      target_users: voucher.target_users || 'new_shopper',
    });
    setSelectedVoucher(voucher);
    setEditVoucherModalOpen(true);
  };

  const handleEditVoucherChange = (e) => {
    setEditVoucher({ ...editVoucher, [e.target.name]: e.target.value });
  };

  const handleEditStartDateChange = (date) => {
    setEditVoucher({ ...editVoucher, start_date: date });
  };

  const handleEditEndDateChange = (date) => {
    setEditVoucher({ ...editVoucher, end_date: date });
  };

  const handleDeleteVoucher = async () => {
    setDeleteVoucherLoading(true);
    try {
      const response = await axiosInstance.delete(`/admin/voucher/${selectedVoucher._id}`);
      
      if (response.status < 300) {
        notify('Voucher deleted successfully!');
        setDeleteConfirmModalOpen(false);
        setSelectedVoucher(null);
        fetchVouchers(); // Refresh the list
      }
    } catch (error) {
      console.error('Error deleting voucher:', error);
      const errorMessage = error.response?.data?.message || 'Failed to delete voucher. Please try again.';
      notifyError(errorMessage);
    } finally {
      setDeleteVoucherLoading(false);
    }
  };

  const openDeleteConfirmModal = (voucher) => {
    setSelectedVoucher(voucher);
    setDeleteConfirmModalOpen(true);
  };

  const handleUpdateVoucher = async (e) => {
    e.preventDefault();
    setEditVoucherLoading(true);
    try {
      const payload = {
        voucher_type: editVoucher.voucher_type,
        medium: editVoucher.medium,
        start_date: editVoucher.start_date,
        end_date: editVoucher.end_date,
        description: editVoucher.description,
        target_users: editVoucher.target_users,
      };
      
      if (editVoucher.voucher_type === 'amount_off') {
        payload.amount = Number(editVoucher.amount);
      } else if (editVoucher.voucher_type === 'percentage_off') {
        payload.percentage = Number(editVoucher.percentage);
      }
      
      if (editVoucher.maximum_amount) {
        payload.maximum_amount = Number(editVoucher.maximum_amount);
      }
      
      if (editVoucher.maximum_amount_per_user) {
        payload.maximum_amount_per_user = Number(editVoucher.maximum_amount_per_user);
      }

      const response = await axiosInstance.put(`/admin/voucher/${selectedVoucher._id}`, payload);
      
      if (response.status < 300) {
        notify('Voucher updated successfully!');
        setEditVoucherModalOpen(false);
        fetchVouchers(); // Refresh the list
      }
    } catch (error) {
      console.error('Error updating voucher:', error);
      const errorMessage = error.response?.data?.message || 'Failed to update voucher. Please try again.';
      notifyError(errorMessage);
    } finally {
      setEditVoucherLoading(false);
    }
  };
  return (
    <>
      <div className="px-2">
        <div className={`${styles.filters} mt-4`}>
          <div className="row">
            <div className={`${styles.hold_input} col-6   `}>
              <img src="/assets/icons/search.svg" alt="" />
              <input
                type="text"
                value={filter.search}
                onChange={(e) => handleFilterChange('search', e.target.value)}
                placeholder="Search"
                style={{ textIndent: '25px', width: '60%' }}
                className=" form-control"
              />
            </div>
            <div className="col-6  text-right">
              <button
                onClick={() => setFilterModalOpen(true)}
                className="btn  border"
                style={{
                  backgroundColor: '#fff',
                  border: '1px solid #D0D5DD',
                  boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)',
                  borderRadius: '4px',
                }}
              >
                <img
                  className=""
                  style={{ display: 'inline', width: '17px' }}
                  src="/assets/icons/filterlines.svg"
                  alt=""
                />
                &nbsp;
                <small className="d-none d-md-inline-block">Filters</small>
              </button>
            </div>
          </div>
        </div>
        <Card
          style={{ marginTop: '50px', borderRadius: '10px' }}
          className="p-0"
        >
          <div className="p-4 border-bottom">
            <div className="d-md-flex justify-content-between">
              <div className="pb-3 pb-md-0">
                {!currentParticipant && (
                  <>
                    <h5 className="table_desc_header">Vouchers</h5>
                    <small style={{ fontWeight: '200', fontSize: '14px' }}>
                      Details of sales made by stores on FlexDeals.
                    </small>
                  </>
                )}
                {currentParticipant && (
                  <>
                    <button onClick={handleClick} className="btn">
                      <div
                        className="p-2"
                        style={{
                          border: '1px solid lightgrey',
                          borderRadius: '3px',
                        }}
                      >
                        <img src="/assets/icons/Chevronleft.svg" alt="" />
                      </div>
                    </button>
                    <h5 className="table_desc_header">Vouchers</h5>
                    <small style={{ fontWeight: '200', fontSize: '14px' }}>
                      View customers who used the voucher
                    </small>
                  </>
                )}
              </div>
              <div className="pt-md-2 d-md-flex">
                <div className="">
                  <button
                    className="btn btn_primaryh"
                    onClick={() => setCreateVoucherModalOpen(true)}
                    style={{
                      border: '1px solid #af3585',
                      color: '#af3585',
                      background: '#8C2D9129',
                      borderRadius: '7px',
                      minHeight: '40px',
                    }}
                  >
                    + <small>Create Vouchers</small>
                  </button>
                </div>
                &nbsp; &nbsp;
                <div className="dropleft ">
                  <button
                    id="dropdownMenuButton"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                    className={`${styles.export_btn} btn m-0`}
                  >
                    <span
                      style={{
                        paddingTop: '8px',
                      }}
                    >
                      <img src="/assets/icons/downloadblue.svg" alt="" /> &nbsp;
                      Export
                    </span>
                    &nbsp; &nbsp;
                    <span
                      style={{
                        borderLeft: '1px solid white',
                        display: 'inline-block',
                        height: 'inherit',
                        paddingTop: '8px',
                        paddingLeft: '8px',
                        textAlign: 'center',
                      }}
                    >
                      <img src="/assets/icons/chevron-downblue.svg" alt="" />
                    </span>
                  </button>
                  <div
                    className="dropdown-menu drop-left"
                    aria-labelledby="dropdownMenuButton"
                  >
                    <button
                      type="button"
                      className="rss dropdown-item btn border-0"
                      onClick={() => handleDownloadFile('csv')}
                    >
                      CSV
                    </button>
                    <button
                      type="button"
                      className="rss dropdown-item btn border-0"
                      onClick={() => handleDownloadFile('excel')}
                    >
                      Excel
                    </button>
                    <button
                      type="button"
                      className="rss dropdown-item btn border-0"
                      onClick={() => handleDownloadFile('pdf')}
                    >
                      PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!currentParticipant && (
            <Scrollbar>
              <div className={`pt-3 pb-3 pl-0 pr-0`}>
                <table
                  className={`${styles.table} table-hover table-striped `}
                  style={{ minWidth: '100em' }}
                >
                  <thead className={`${styles.thead}`}>
                    <tr>
                      <th className="text-muted">S/N</th>
                      <th className="text-muted" style={{ width: '16rem' }}>
                        Voucher Code
                        <img
                          className="pl-2"
                          src="/assets/icons/down.svg"
                          alt=""
                        />
                      </th>
                      <th className="text-muted">Voucher Type</th>
                      <th className="text-muted">Target Users</th>
                      <th className="text-muted">Status</th>
                      <th className="text-muted">Number of Participant</th>
                      <th className="text-muted">Start Date</th>
                      <th className="text-muted">Expiry Date</th>
                      <th className="text-muted">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isPending &&
                      vouchersData.length >= 1 &&
                      vouchersData.map((el, i) => (
                        <tr className={`${styles.tr} `}>
                          <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                          <td>
                            <p>{el?.code ? el.code : '---'}</p>
                          </td>
                          <td>
                            <p>{el?.amount ? `₦${el.amount}` : el?.percentage ? `${el.percentage}%` : '---'}</p>
                          </td>
                          <td>
                            <p>{el?.target_users ? el.target_users : '---'}</p>
                          </td>
                          <td>
                            <span className="">
                              {el?.start_date && el?.end_date ? (
                                new Date() >= new Date(el.start_date) && new Date() <= new Date(el.end_date) ? (
                                  <span className="verified_badge">
                                    <img
                                      src="/assets/icons/check-circlel.svg"
                                      alt=""
                                    />
                                    Active
                                  </span>
                                ) : new Date() > new Date(el.end_date) ? (
                                  <span className="not_verified_badge">
                                    Ended
                                  </span>
                                ) : (
                                  <span className="pending_verified_badge">
                                    Pending
                                  </span>
                                )
                              ) : (
                                <span className="pending_verified_badge">
                                  Pending
                                </span>
                              )}
                            </span>
                          </td>
                          <td>
                            {el?.medium ? el.medium.length : 0}
                          </td>
                          <td>
                            <span>
                              {el?.start_date
                                ? moment(el?.start_date).format('DD/MM/YYYY')
                                : 'NOT SET'}
                            </span>{' '}
                            <br />
                            <small>
                              {el?.start_date
                                ? moment(el?.start_date).format('HH:mm')
                                : 'NOT SET'}{' '}
                              PM
                            </small>
                          </td>
                          <td>
                            <span>
                              {el?.end_date
                                ? moment(el?.end_date).format('DD/MM/YYYY')
                                : 'NOT SET'}
                            </span>{' '}
                            <br />
                            <small>
                              {el?.end_date
                                ? moment(el?.end_date).format('HH:mm')
                                : 'NOT SET'}{' '}
                              PM
                            </small>
                          </td>
                          <td>
                            <div className="dropleft ">
                              <span
                                id="dropdownMenuButton"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                                className={`${styles.action_button} px-3 py-2`}
                                style={{
                                  cursor: 'pointer',
                                }}
                              >
                                <img src="/assets/icons/action.svg" alt="" />
                              </span>

                              <div
                                className="dropdown-menu drop-left"
                                aria-labelledby="dropdownMenuButton"
                              >
                                <button
                                  type="button"
                                  onClick={() => {
                                    handleViewVoucher(el);
                                  }}
                                  className="rss dropdown-item btn border-0"
                                >
                                  View
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    handleEditVoucher(el);
                                  }}
                                  className="rss dropdown-item btn border-0"
                                >
                                                                    Edit
                                </button>
                                <button
                                  type="button"
                                  onClick={() => {
                                    openDeleteConfirmModal(el);
                                  }}
                                  className="rss dropdown-item btn border-0 text-danger"
                                >
                                  Delete
                                </button>
                                </div>
                              </div>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
              </div>
              <div className="d-flex justify-content-center">
                {isPending && (
                  <BallTriangle
                    height={50}
                    width={55}
                    radius={5}
                    color="#af3585"
                    ariaLabel="ball-triangle-loading"
                    wrapperClass={{}}
                    wrapperStyle=""
                    visible={true}
                  />
                )}
              </div>
              {!vouchersData.length && !isPending && (
                <div className="alert alert-[#af3585] text-center">
                  <h4>No record found</h4>
                </div>
              )}
            </Scrollbar>
          )}
          {currentParticipant && (
            <Scrollbar>
              <div className={`pt-3 pb-3 pl-0 pr-0`}>
                <table
                  className={`${styles.table} table-hover table-striped `}
                  style={{ minWidth: '100em' }}
                >
                  <thead className={`${styles.thead}`}>
                    <tr>
                      <th className="text-muted">S/N</th>
                      <th className="text-muted" style={{ width: '16rem' }}>
                        Shopper Name
                        <img
                          className="pl-2"
                          src="/assets/icons/down.svg"
                          alt=""
                        />
                      </th>
                      <th className="text-muted">Phone Number</th>
                      <th className="text-muted">Address</th>
                      <th className="text-muted">Total Order</th>
                      <th className="text-muted">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isPending &&
                      vouchersData.length >= 1 &&
                      vouchersData.map((el, i) => (
                        <tr className={`${styles.tr} `}>
                          <td>{(currentPage - 1) * itemsPerPage + i + 1}</td>
                          <td>
                            <div className="d-flex justify-content-start align-items-center">
                              <Avatar
                                className={`${styles.avatrr} mr-3 float-md-left`}
                                alt=""
                                src={el?.store_logo}
                              />

                              <div className="">
                                <p
                                  className="mb-0"
                                  style={{
                                    fontSize: '14px',
                                    whiteSpace: 'wrap',
                                  }}
                                >
                                  {el?.onboarded_by && (
                                    <small
                                      className="px-2 py-0 rounded text-[#af3585] d-block"
                                      style={{
                                        width: 'fit-content',
                                        fontSize: '11px',
                                        background: '#E8F3FB',
                                        letterSpacing: '1px',
                                      }}
                                    >
                                      Invite
                                    </small>
                                  )}
                                  {el?.store_name ? el.store_name : '---'}
                                </p>
                                <span>{el?.storeID ? el.storeID : '---'}</span>
                              </div>
                            </div>
                          </td>
                          <td>
                            <p>{el?.phone ? el.phone : '---'}</p>
                          </td>
                          <td>
                            <p>{el?.address ? el.address : '---'}</p>
                          </td>
                          <td>
                            {el?.number_of_participants
                              ? el.number_of_participants
                              : 0}
                          </td>
                          <td>
                            <span>
                              {el?.date_registered
                                ? moment(el?.date_registered).format(
                                    'DD/MM/YYYY'
                                  )
                                : 'NOT SET'}
                            </span>{' '}
                            <br />
                            <small>
                              {el?.date_registered
                                ? moment(el?.date_registered).format('HH:mm')
                                : 'NOT SET'}{' '}
                              PM
                            </small>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
              <div className="d-flex justify-content-center">
                {isPending && (
                  <BallTriangle
                    height={50}
                    width={55}
                    radius={5}
                    color="#af3585"
                    ariaLabel="ball-triangle-loading"
                    wrapperClass={{}}
                    wrapperStyle=""
                    visible={true}
                  />
                )}
              </div>
              {!vouchersData.length && !isPending && (
                <div className="alert alert-[#af3585] text-center">
                  <h4>No record found</h4>
                </div>
              )}
            </Scrollbar>
          )}
          <div>
            <Pagination
              currentPage={currentPage}
              dataPagination={dataPagination}
              itemsPerPage={itemsPerPage}
              setCurrentPage={setCurrentPage}
              fetchData={fetchData}
            />
          </div>
        </Card>
      </div>

      {/* Fiter Modal */}
      {/* <GlobalModal
                open={filterModalOpen}
                onClose={handleCloseFilter}
                position="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                width="740px !important"
                overflow="auto"
                bgcolor="#FFFFFF"
                border="1px solid #F5F5F5"
                borderRadius="5px"
                boxShadow="24"
                p="25px"
            >
                <div className={`${styles.modal_content}`}>
                <div className={`${styles.modal_header} mb-0`}>
                    <h5
                        style={{
                            fontSize: "19px",
                            fontWeight: "700",
                        }}
                    >
                        Filter
                    </h5>
                    <span onClick={handleCloseFilter} style={{ cursor: "pointer" }}>
                    <img src="/assets/icons/x.svg" alt="" />
                    </span>
                </div>

                <form action="" className="mt-0">
                    <div className="row">
                    <div className="col-md-6 mb-1">
                        <div className="mb-3">
                        <label htmlFor="name">Verification</label>
                        <Select
                            labelId="s"
                            id="s"
                            fullWidth
                            size="small"
                            value={filter.verified}
                            onChange={(e) => handleFilterChange('verified', e.target.value)}
                        >
                            <MenuItem value="select">Select Customer Status</MenuItem>
                            <MenuItem value={true}>Verified</MenuItem>
                            <MenuItem value={false}>Unverified</MenuItem>
                        </Select>
                        </div>

                        <div className="">
                        <div className="mb-3">
                            <LiveLocation label='Location' passData={processLocation} />
                        </div>
                        </div>

                        <label htmlFor="ounit">Brands </label>
                        <div className=" d-flex">
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                type="number"
                                value={filter.min_brands}
                                id="ounit"
                                placeholder=""
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('min_brands', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        <div
                            className="px-1 d-flex   align-items-center "
                            style={{ height: "40px" }}
                        >
                            <img
                            src="/assets/icons/line.svg"
                            style={{ width: "30px" }}
                            alt=""
                            />
                        </div>
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                type="number"
                                value={filter.max_brands}
                                placeholder=""
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('max_brands', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        </div>
                    </div>
                    <div className="col-md-6 mb-1">
                        <label htmlFor="price">Date </label>

                        <div className=" d-flex">
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <DatePicker
                                showIcon
                                selected={startDate}
                                onChange={(date) => setStartDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="Start"
                                required
                                maxDate={new Date()}
                            />
                            </div>
                        </div>
                        <div
                            className="px-1 d-flex   align-items-center "
                            style={{ height: "40px" }}
                        >
                            <img
                            src="/assets/icons/line.svg"
                            style={{ width: "30px" }}
                            alt=""
                            />
                        </div>
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <DatePicker
                                showIcon
                                selected={endDate}
                                onChange={(date) => setEndDate(date)}
                                dateFormat="dd/MM/yyyy"
                                className="form-control"
                                placeholderText="End"
                                required
                                maxDate={new Date()}
                            />
                            </div>
                        </div>
                        </div>

                        <label htmlFor="ounit">Wallet Balance </label>
                        <div className=" d-flex">
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                type="number"
                                value={filter.min_balance}
                                id="ounit"
                                placeholder="Min"
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('min_balance', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        <div
                            className="px-1 d-flex   align-items-center "
                            style={{ height: "40px" }}
                        >
                            <img
                            src="/assets/icons/line.svg"
                            style={{ width: "30px" }}
                            alt=""
                            />
                        </div>
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                value={filter.max_balance}
                                type="number"
                                placeholder="Max "
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('max_balance', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        </div>

                        <label htmlFor="ounit">Order Unit </label>
                        <div className=" d-flex">
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                value={filter.min_order_unit}
                                type="number"
                                id="ounit"
                                placeholder="Min"
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('min_order_unit', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        <div
                            className="px-1 d-flex   align-items-center "
                            style={{ height: "40px" }}
                        >
                            <img
                            src="/assets/icons/line.svg"
                            style={{ width: "30px" }}
                            alt=""
                            />
                        </div>
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                type="number"
                                value={filter.max_order_unit}
                                placeholder="Max "
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('max_order_unit', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        </div>

                        <label htmlFor="ounit">Product Categories </label>
                        <div className=" d-flex">
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                value={filter.min_categories}
                                type="number"
                                id="ounit"
                                placeholder=""
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('min_categories', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        <div
                            className="px-1 d-flex   align-items-center "
                            style={{ height: "40px" }}
                        >
                            <img
                            src="/assets/icons/line.svg"
                            style={{ width: "30px" }}
                            alt=""
                            />
                        </div>
                        <div className="" style={{ width: "100%" }}>
                            <div className="mb-3">
                            <TextField
                                required
                                type="number"
                                value={filter.max_categories}
                                placeholder=""
                                size="small"
                                onChange={(e) => {
                                const inputValue = e.target.value;
                                if (inputValue === '' || parseFloat(inputValue) >= 0) {
                                    handleFilterChange('max_categories', inputValue);
                                }
                                }}
                                inputProps={{
                                    inputMode: 'decimal',
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                    <div className="mb-4">
                    <button
                        type="button"
                        onClick={() => {
                        handleCloseFilter();
                        fetchData()
                        }}
                        className={`${styles.modal_btn} btn btn-block`}
                    >
                        Proceed{" "}
                        {isPending && (
                        <CircularProgress style={{ color: "#fff" }} size="1rem" />
                        )}
                    </button>
                    </div>
                </form>
                </div>
            </GlobalModal> */}

      {/* View Current */}
      <GlobalModal
        open={viewCurrentVoucher}
        onClose={() => setViewCurrentVoucher(false)}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="740px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className="card border-0">
          <div className="card-body border-0 ">
            <div className={`${styles.customized_row}`}>
              <div className="">
                <img
                  style={{ width: '40px' }}
                  src="/assets/icons/caution.svg"
                  alt=""
                />
              </div>
              <div>
                <h4>Verify {currentData.store_name}</h4>
                <p
                  style={{
                    fontSize: '14px',
                    color: '#6B7280',
                  }}
                >
                  Are you sure you want to perform this operation
                </p>
              </div>
            </div>

            <DialogActions>
              <Button
                className={`${styles.cancel_delete}`}
                onClick={() => setViewCurrentVoucher(false)}
              >
                Cancel
              </Button>
              <Button
                className={`${styles.delete_product}`}
                // onClick={verifyUser}
              >
                Verify{' '}
                {loadingState && (
                  <CircularProgress style={{ color: '#af3585' }} size="1rem" />
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </GlobalModal>

      {/* View Voucher Modal */}
      <GlobalModal
        open={viewVoucherModalOpen}
        onClose={() => setViewVoucherModalOpen(false)}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="600px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className={`${styles.modal_content}`}>
          <div className={`${styles.modal_header} mb-0`}>
            <h5
              style={{
                fontSize: '19px',
                fontWeight: '700',
              }}
            >
              Voucher Details
            </h5>
            <span onClick={() => setViewVoucherModalOpen(false)} style={{ cursor: 'pointer' }}>
              <img src="/assets/icons/x.svg" alt="" />
            </span>
          </div>
          
          {selectedVoucher && !viewVoucherLoading ? (
            <div className="mt-4">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Voucher Code</label>
                  <p className="text-muted">{selectedVoucher.code}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Amount/Percentage</label>
                  <p className="text-muted">
                    {selectedVoucher.amount ? `₦${selectedVoucher.amount}` : 
                     selectedVoucher.percentage ? `${selectedVoucher.percentage}%` : '---'}
                  </p>
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Description</label>
                  <p className="text-muted">{selectedVoucher.description || '---'}</p>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Target Users</label>
                  <p className="text-muted">{selectedVoucher.target_users || '---'}</p>
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Medium</label>
                  <p className="text-muted">
                    {selectedVoucher.medium && selectedVoucher.medium.length > 0 
                      ? selectedVoucher.medium.join(', ') 
                      : '---'}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Status</label>
                  <p className="text-muted">
                    {selectedVoucher.start_date && selectedVoucher.end_date ? (
                      new Date() >= new Date(selectedVoucher.start_date) && new Date() <= new Date(selectedVoucher.end_date) ? (
                        <span className="verified_badge">Active</span>
                      ) : new Date() > new Date(selectedVoucher.end_date) ? (
                        <span className="not_verified_badge">Ended</span>
                      ) : (
                        <span className="pending_verified_badge">Pending</span>
                      )
                    ) : (
                      <span className="pending_verified_badge">Pending</span>
                    )}
                  </p>
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Start Date</label>
                  <p className="text-muted">
                    {selectedVoucher.start_date 
                      ? moment(selectedVoucher.start_date).format('DD/MM/YYYY HH:mm')
                      : '---'}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">End Date</label>
                  <p className="text-muted">
                    {selectedVoucher.end_date 
                      ? moment(selectedVoucher.end_date).format('DD/MM/YYYY HH:mm')
                      : '---'}
                  </p>
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Created By</label>
                  <p className="text-muted">
                    {selectedVoucher.created_by ? 
                      (typeof selectedVoucher.created_by === 'object' ? 
                        selectedVoucher.created_by.email || selectedVoucher.created_by.first_name || '---' : 
                        selectedVoucher.created_by) 
                      : '---'}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Created At</label>
                  <p className="text-muted">
                    {selectedVoucher.createdAt 
                      ? moment(selectedVoucher.createdAt).format('DD/MM/YYYY HH:mm')
                      : '---'}
                  </p>
                </div>
              </div>
              
              <div className="row">
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Last Updated</label>
                  <p className="text-muted">
                    {selectedVoucher.updatedAt 
                      ? moment(selectedVoucher.updatedAt).format('DD/MM/YYYY HH:mm')
                      : '---'}
                  </p>
                </div>
                <div className="col-md-6 mb-3">
                  <label className="font-weight-bold">Voucher ID</label>
                  <p className="text-muted">{selectedVoucher._id}</p>
                </div>
              </div>
            </div>
          ) : viewVoucherLoading ? (
            <div className="mt-4 text-center">
              <CircularProgress size={40} style={{ color: '#af3585' }} />
              <p className="mt-2">Loading voucher details...</p>
            </div>
          ) : (
            <div className="mt-4 text-center">
              <p>No voucher data available</p>
            </div>
          )}
          
          <div className="mb-4 mt-3">
            <button 
              type="button" 
              className={`${styles.modal_btn} btn btn-block`}
              onClick={() => setViewVoucherModalOpen(false)}
            >
              Close
            </button>
          </div>
        </div>
      </GlobalModal>

      <GlobalModal
        open={filterModalOpen}
        onClose={handleCloseFilter}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="740px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className={`${styles.modal_content}`}>
          <div className={`${styles.modal_header} mb-0`}>
            <h5
              style={{
                fontSize: '19px',
                fontWeight: '700',
              }}
            >
              Filter
            </h5>
            <span onClick={handleCloseFilter} style={{ cursor: 'pointer' }}>
              <img src="/assets/icons/x.svg" alt="" />
            </span>
          </div>

          <form action="" className="mt-0">
            <div className="row">
              <div className="col-md-6 mb-1">
                <div className="mb-3">
                  <LiveLocation label="Location" passData={processLocation} />
                </div>
                <div className="mb-3">
                  <label className="font-weight-boldd" htmlFor="name">
                    Status
                  </label>
                  <Select
                    labelId="s"
                    id="s"
                    fullWidth
                    size="small"
                    value={filter.category}
                    defaultValue={'select'}
                    name="category"
                    required
                    onChange={(e) =>
                      handleFilterChange('category', e.target.value)
                    }
                  >
                    <MenuItem value="select">Select Status</MenuItem>
                    <MenuItem value="pending">Pending</MenuItem>
                    <MenuItem value="completed">Completed</MenuItem>
                  </Select>
                </div>

                <div className="mb-3">
                  <label className="font-weight-boldd" htmlFor="name">
                    Payment Method
                  </label>
                  <Select
                    labelId="mod"
                    id="mod"
                    fullWidth
                    size="small"
                    name="filterStatus"
                    value={filter.filterStatus}
                    defaultValue={'select'}
                    required
                    onChange={(e) =>
                      handleFilterChange('filterStatus', e.target.value)
                    }
                  >
                    <MenuItem value="select">Select Payment Method</MenuItem>
                    <MenuItem value="cash">Cash</MenuItem>
                    <MenuItem value="card">Card</MenuItem>
                    <MenuItem value="transfer">Transfer</MenuItem>
                    <MenuItem value="wallet">Wallet</MenuItem>
                  </Select>
                </div>
              </div>
              <div className="col-md-6 mb-1">
                <label htmlFor="price">Date </label>
                <div className=" d-flex">
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <DatePicker
                        showIcon
                        selected={startDate}
                        onChange={(date) => setStartDate(date)}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        placeholderText="Start"
                        required
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                  <div
                    className="px-1 d-flex   align-items-center "
                    style={{ height: '40px' }}
                  >
                    <img
                      src="/assets/icons/line.svg"
                      style={{ width: '30px' }}
                      alt=""
                    />
                  </div>
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <DatePicker
                        showIcon
                        selected={endDate}
                        onChange={(date) => setEndDate(date)}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                        placeholderText="End"
                        required
                        maxDate={new Date()}
                      />
                    </div>
                  </div>
                </div>
                <div>
                  <label htmlFor="patronage">Price </label>
                  <div className=" d-flex">
                    <div className="" style={{ width: '100%' }}>
                      <div className="mb-3">
                        <TextField
                          required
                          type="number"
                          id="price"
                          placeholder="Min"
                          size="small"
                          name="priceFilter"
                          value={filter.priceFilter}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (
                              inputValue === '' ||
                              parseFloat(inputValue) >= 0
                            ) {
                              handleFilterChange('priceFilter', inputValue);
                            }
                          }}
                          inputProps={{
                            inputMode: 'decimal',
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === '-' ||
                              e.key === 'e' ||
                              e.key === '.'
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                    <div
                      className="px-1 d-flex   align-items-center "
                      style={{ height: '40px' }}
                    >
                      <img
                        src="/assets/icons/line.svg"
                        style={{ width: '30px' }}
                        alt=""
                      />
                    </div>
                    <div className="" style={{ width: '100%' }}>
                      <div className="mb-3">
                        <TextField
                          required
                          type="number"
                          placeholder="Max "
                          size="small"
                          name="priceToFilter"
                          value={filter.priceToFilter}
                          onChange={(e) => {
                            const inputValue = e.target.value;
                            if (
                              inputValue === '' ||
                              parseFloat(inputValue) >= 0
                            ) {
                              handleFilterChange('priceToFilter', inputValue);
                            }
                          }}
                          inputProps={{
                            inputMode: 'decimal',
                          }}
                          onKeyDown={(e) => {
                            if (
                              e.key === '-' ||
                              e.key === 'e' ||
                              e.key === '.'
                            ) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <label htmlFor="ounit">Order Unit </label>
                <div className=" d-flex">
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <TextField
                        required
                        type="number"
                        id="ounit"
                        placeholder="Min"
                        size="small"
                        name="orderUnitFilter"
                        value={filter.orderUnitFilter}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            inputValue === '' ||
                            parseFloat(inputValue) >= 0
                          ) {
                            handleFilterChange('orderUnitFilter', inputValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === '.') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                  <div
                    className="px-1 d-flex   align-items-center "
                    style={{ height: '40px' }}
                  >
                    <img
                      src="/assets/icons/line.svg"
                      style={{ width: '30px' }}
                      alt=""
                    />
                  </div>
                  <div className="" style={{ width: '100%' }}>
                    <div className="mb-3">
                      <TextField
                        required
                        type="number"
                        id="ounit"
                        placeholder="Min"
                        size="small"
                        name="orderUnitToFilter"
                        value={filter.orderUnitToFilter}
                        onChange={(e) => {
                          const inputValue = e.target.value;
                          if (
                            inputValue === '' ||
                            parseFloat(inputValue) >= 0
                          ) {
                            handleFilterChange('orderUnitToFilter', inputValue);
                          }
                        }}
                        inputProps={{
                          inputMode: 'decimal',
                        }}
                        onKeyDown={(e) => {
                          if (e.key === '-' || e.key === 'e' || e.key === '.') {
                            e.preventDefault();
                          }
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-4">
              <button
                type="button"
                onClick={handleSubmitFilter}
                className={`${styles.modal_btn} btn btn-block`}
              >
                Proceed
              </button>
            </div>
          </form>
        </div>
      </GlobalModal>
      <GlobalModal
        open={createVoucherModalOpen}
        onClose={() => setCreateVoucherModalOpen(false)}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="740px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className={`${styles.modal_content} scrollable-modal`} style={{ 
          maxHeight: '70vh', 
          overflowY: 'auto', 
          overflowX: 'hidden'
        }}>
          <div className={`${styles.modal_header} mb-0`}>
            <h5
              style={{
                 fontSize: '19px',
                fontWeight: '700',
              }}
            >
              Create Vouchers
            </h5>
            <span onClick={() => setCreateVoucherModalOpen(false)} style={{ cursor: 'pointer' }}>
              <img src="/assets/icons/x.svg" alt="" />
            </span>
          </div>
          <p className="text-muted">Create a new voucher for your customers</p>

          <form action="" className="mt-4" onSubmit={handleCreateVoucher}>
            {/* Upload Banner Section */}
            <div className="mb-3">
              <label>Upload Banner</label>
              <ImageUploader imageResult={handleBannerUpload} />
              <small className="text-muted">Recommended size 40px by 40px.</small>
            </div>

            {/* Voucher Type Section */}
            <div className="mb-3">
              <label className="font-weight-boldd" htmlFor="voucher_type">
                Vouchers Type*
              </label>
              <Select
                labelId="voucher_type"
                id="voucher_type"
                fullWidth
                size="small"
                value={newVoucher.voucher_type}
                name="voucher_type"
                required
                onChange={handleCreateVoucherChange}
              >
                <MenuItem value="percentage_off">Percentage off</MenuItem>
                <MenuItem value="amount_off">Amount Off</MenuItem>
              </Select>
            </div>

            {/* Percentage/Amount Input based on voucher type */}
            {newVoucher.voucher_type === 'percentage_off' && (
              <div className="mb-3">
                <label htmlFor="percentage">Set Percentage *</label>
                <TextField
                  required
                  fullWidth
                  type="number"
                  id="percentage"
                  placeholder="20"
                  size="small"
                  name="percentage"
                  value={newVoucher.percentage}
                  onChange={handleCreateVoucherChange}
                  InputProps={{
                    endAdornment: <InputAdornment position="end">%</InputAdornment>,
                  }}
                />
                
                {/* Set Maximum Amount Link */}
                <div className="mt-2">
                  <span 
                    style={{ 
                      color: '#af3585', 
                      cursor: 'pointer', 
                      textDecoration: 'underline',
                      fontSize: '14px'
                    }}
                    onClick={() => setShowMinOrderAndMaxDiscount(!showMinOrderAndMaxDiscount)}
                  >
                    Set Maximum Amount
                  </span>
                </div>

                {/* Show additional fields when link is clicked */}
                {showMinOrderAndMaxDiscount && (
                  <div className="mt-3">
                    <div className="row">
                      <div className="col-md-4 mb-3">
                        <label htmlFor="minimum_order_amount">Minimum order amount *</label>
                        <TextField
                          required
                          fullWidth
                          type="number"
                          id="minimum_order_amount"
                          placeholder="100"
                          size="small"
                          name="minimum_order_amount"
                          value={newVoucher.minimum_order_amount}
                          onChange={handleCreateVoucherChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                          }}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="maximum_amount">Maximum amount *</label>
                        <TextField
                          required
                          fullWidth
                          type="number"
                          id="maximum_amount"
                          placeholder="1000"
                          size="small"
                          name="maximum_amount"
                          value={newVoucher.maximum_amount}
                          onChange={handleCreateVoucherChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                          }}
                        />
                      </div>
                      <div className="col-md-4 mb-3">
                        <label htmlFor="maximum_amount_per_user">Maximum discount per user *</label>
                        <TextField
                          required
                          fullWidth
                          type="number"
                          id="maximum_amount_per_user"
                          placeholder="50"
                          size="small"
                          name="maximum_amount_per_user"
                          value={newVoucher.maximum_amount_per_user}
                          onChange={handleCreateVoucherChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {newVoucher.voucher_type === 'amount_off' && (
              <div className="mb-3">
                <label htmlFor="amount">Amount *</label>
                <TextField
                  required
                  fullWidth
                  type="number"
                  id="amount"
                  placeholder="30"
                  size="small"
                  name="amount"
                  value={newVoucher.amount}
                  onChange={handleCreateVoucherChange}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                  }}
                />
                
                {/* Set Minimum Amount Link */}
                <div className="mt-2">
                  <span 
                    style={{ 
                      color: '#af3585', 
                      cursor: 'pointer', 
                      textDecoration: 'underline',
                      fontSize: '14px'
                    }}
                    onClick={() => setShowMinAmountForAmountOff(!showMinAmountForAmountOff)}
                  >
                    Set minimum amount
                  </span>
                </div>

                {/* Show minimum order amount field when link is clicked */}
                {showMinAmountForAmountOff && (
                  <div className="mt-3">
                    <div className="row">
                      <div className="col-md-12 mb-3">
                        <label htmlFor="minimum_order_amount_amount_off">Minimum order amount</label>
                        <TextField
                          fullWidth
                          type="number"
                          id="minimum_order_amount_amount_off"
                          placeholder="100"
                          size="small"
                          name="minimum_order_amount"
                          value={newVoucher.minimum_order_amount}
                          onChange={handleCreateVoucherChange}
                          InputProps={{
                            startAdornment: <InputAdornment position="start">₦</InputAdornment>,
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}

            {/* Target Users Section */}
            <div className="mb-3">
              <label className="font-weight-boldd" htmlFor="target_users">
                Target Users
              </label>
              <Select
                labelId="target_users"
                id="target_users"
                fullWidth
                size="small"
                value={newVoucher.target_users}
                name="target_users"
                required
                onChange={handleCreateVoucherChange}
                displayEmpty
              >
                <MenuItem value="" disabled>Select</MenuItem>
                <MenuItem value="offline_shopper">Offline Shopper</MenuItem>
                <MenuItem value="new_shopper">New Shopper</MenuItem>
                <MenuItem value="active_shopper">Active Shopper</MenuItem>
                <MenuItem value="inactive_shopper">Inactive Shopper</MenuItem>
                <MenuItem value="all_shopper">All Shopper</MenuItem>
              </Select>
            </div>

            {/* Medium Section */}
            <div className="mb-3">
              <label>Medium</label>
              <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap', marginTop: '8px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    checked={newVoucher.medium.includes('email')}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setNewVoucher({
                          ...newVoucher,
                          medium: [...newVoucher.medium, 'email']
                        });
                      } else {
                        setNewVoucher({
                          ...newVoucher,
                          medium: newVoucher.medium.filter(m => m !== 'email')
                        });
                      }
                    }}
                  />
                  Email
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    checked={newVoucher.medium.includes('sms')}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setNewVoucher({
                          ...newVoucher,
                          medium: [...newVoucher.medium, 'sms']
                        });
                      } else {
                        setNewVoucher({
                          ...newVoucher,
                          medium: newVoucher.medium.filter(m => m !== 'sms')
                        });
                      }
                    }}
                  />
                  SMS
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    checked={newVoucher.medium.includes('in-app')}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setNewVoucher({
                          ...newVoucher,
                          medium: [...newVoucher.medium, 'in-app']
                        });
                      } else {
                        setNewVoucher({
                          ...newVoucher,
                          medium: newVoucher.medium.filter(m => m !== 'in-app')
                        });
                      }
                    }}
                  />
                  In-App Notification
                </label>
              </div>
            </div>

            {/* Set Time Section */}
            <div className="mb-3">
              <label>Set Time</label>
              <div className="row mt-2">
                <div className="col-md-6">
                  <label htmlFor="start_date" style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}>Start Date</label>
                  <DatePicker
                    showIcon
                    selected={newVoucher.start_date}
                    onChange={handleStartDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    placeholderText="Now"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label htmlFor="end_date" style={{ fontSize: '14px', marginBottom: '8px', display: 'block' }}>End Date</label>
                  <DatePicker
                    showIcon
                    selected={newVoucher.end_date}
                    onChange={handleExpiryDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    placeholderText="Select end date"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Description Section */}
            <div className="mb-3">
              <label htmlFor="description">Description</label>
              <TextField
                fullWidth
                multiline
                rows={3}
                type="text"
                id="description"
                placeholder="20% off your total order"
                size="small"
                name="description"
                value={newVoucher.description}
                onChange={handleCreateVoucherChange}
              />
            </div>

            {/* Hidden fields for now - can be removed if not needed */}
            <input type="hidden" name="input_code" value={newVoucher.input_code} />
            <input type="hidden" name="discount_occurence" value={newVoucher.discount_occurence} />

            <div className="mb-4 mt-3">
              <button 
                type="submit" 
                className={`${styles.modal_btn} btn btn-block`}
                disabled={isPending}
                style={{
                  backgroundColor: '#af3585',
                  color: 'white',
                  border: 'none',
                  borderRadius: '8px',
                  padding: '12px',
                  fontSize: '16px',
                  fontWeight: '500'
                }}
              >
                {isPending ? (
                  <>
                    <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
                    Creating...
                  </>
                ) : (
                  'Create'
                )}
              </button>
            </div>
          </form>
        </div>
      </GlobalModal>

      {/* Edit Voucher Modal */}
      <GlobalModal
        open={editVoucherModalOpen}
        onClose={() => setEditVoucherModalOpen(false)}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="740px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className={`${styles.modal_content} scrollable-modal`} style={{ 
          maxHeight: '70vh', 
          overflowY: 'auto', 
          overflowX: 'hidden'
        }}>
          <div className={`${styles.modal_header} mb-0`}>
            <h5
              style={{
                fontSize: '19px',
                fontWeight: '700',
              }}
            >
              Edit Voucher
            </h5>
            <span onClick={() => setEditVoucherModalOpen(false)} style={{ cursor: 'pointer' }}>
              <img src="/assets/icons/x.svg" alt="" />
            </span>
          </div>
          <p className="text-muted">Update voucher details</p>

          <form action="" className="mt-4" onSubmit={handleUpdateVoucher}>
            <div className="mb-3">
              <label htmlFor="edit_description">Description *</label>
              <TextField
                required
                fullWidth
                type="text"
                id="edit_description"
                placeholder="Enter voucher description"
                size="small"
                name="description"
                value={editVoucher.description}
                onChange={handleEditVoucherChange}
              />
            </div>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="font-weight-boldd" htmlFor="edit_voucher_type">
                  Vouchers Type*
                </label>
                <Select
                  labelId="edit_voucher_type"
                  id="edit_voucher_type"
                  fullWidth
                  size="small"
                  value={editVoucher.voucher_type}
                  name="voucher_type"
                  required
                  onChange={handleEditVoucherChange}
                >
                  <MenuItem value="amount_off">Amount Off</MenuItem>
                  <MenuItem value="percentage_off">Percentage Off</MenuItem>
                </Select>
              </div>
              {editVoucher.voucher_type === 'amount_off' && (
                <div className="col-md-6 mb-3">
                  <label htmlFor="edit_amount">Amount *</label>
                  <TextField
                    required
                    fullWidth
                    type="number"
                    id="edit_amount"
                    placeholder="30"
                    size="small"
                    name="amount"
                    value={editVoucher.amount}
                    onChange={handleEditVoucherChange}
                  />
                </div>
              )}
              {editVoucher.voucher_type === 'percentage_off' && (
                <div className="col-md-6 mb-3">
                  <label htmlFor="edit_percentage">Percentage *</label>
                  <TextField
                    required
                    fullWidth
                    type="number"
                    id="edit_percentage"
                    placeholder="10"
                    size="small"
                    name="percentage"
                    value={editVoucher.percentage}
                    onChange={handleEditVoucherChange}
                    InputProps={{
                      endAdornment: <InputAdornment position="end">%</InputAdornment>,
                    }}
                  />
                </div>
              )}
            </div>
            
            <div className="mb-3">
              <label>Distribution Medium</label>
              <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                {['sms', 'email', 'in-app'].map((medium) => (
                  <label key={medium} style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                    <input
                      type="checkbox"
                      checked={editVoucher.medium.includes(medium)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setEditVoucher({
                            ...editVoucher,
                            medium: [...editVoucher.medium, medium]
                          });
                        } else {
                          setEditVoucher({
                            ...editVoucher,
                            medium: editVoucher.medium.filter(m => m !== medium)
                          });
                        }
                      }}
                    />
                    {medium.charAt(0).toUpperCase() + medium.slice(1)}
                  </label>
                ))}
              </div>
            </div>

            <div className="row">
              <div className="col-md-6 mb-3">
                <label htmlFor="edit_maximum_amount">Maximum Amount</label>
                <TextField
                  fullWidth
                  type="number"
                  id="edit_maximum_amount"
                  placeholder="300"
                  size="small"
                  name="maximum_amount"
                  value={editVoucher.maximum_amount}
                  onChange={handleEditVoucherChange}
                />
              </div>
              <div className="col-md-6 mb-3">
                <label htmlFor="edit_maximum_amount_per_user">Maximum Amount Per User</label>
                <TextField
                  fullWidth
                  type="number"
                  id="edit_maximum_amount_per_user"
                  placeholder="50"
                  size="small"
                  name="maximum_amount_per_user"
                  value={editVoucher.maximum_amount_per_user}
                  onChange={handleEditVoucherChange}
                />
              </div>
            </div>

            <div className="mb-3">
              <label className="font-weight-boldd" htmlFor="edit_target_users">
                Target Users
              </label>
              <Select
                labelId="edit_target_users"
                id="edit_target_users"
                fullWidth
                size="small"
                value={editVoucher.target_users}
                name="target_users"
                required
                onChange={handleEditVoucherChange}
              >
                <MenuItem value="new_shopper">New Shopper</MenuItem>
                <MenuItem value="offline_shopper">Offline Shopper</MenuItem>
                <MenuItem value="active_shopper">Active Shopper</MenuItem>
                <MenuItem value="inactive_shopper">Inactive Shopper</MenuItem>
                <MenuItem value="all_shopper">All Shopper</MenuItem>
              </Select>
            </div>

            <div className="mb-3">
              <label>Validity Period</label>
              <div className="row">
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    selected={editVoucher.start_date}
                    onChange={handleEditStartDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    placeholderText="Start Date"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <DatePicker
                    showIcon
                    selected={editVoucher.end_date}
                    onChange={handleEditEndDateChange}
                    dateFormat="dd/MM/yyyy"
                    className="form-control"
                    placeholderText="End Date"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="mb-4 mt-3">
              <button 
                type="submit" 
                className={`${styles.modal_btn} btn btn-block`}
                disabled={editVoucherLoading}
              >
                {editVoucherLoading ? (
                  <>
                    <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
                    Updating...
                  </>
                ) : (
                  'Update Voucher'
                )}
              </button>
            </div>
          </form>
        </div>
            </GlobalModal>

      {/* Delete Confirmation Modal */}
      <GlobalModal
        open={deleteConfirmModalOpen}
        onClose={() => setDeleteConfirmModalOpen(false)}
        position="absolute"
        top="50%"
        left="50%"
        transform="translate(-50%, -50%)"
        width="400px !important"
        overflow="auto"
        bgcolor="#FFFFFF"
        border="1px solid #F5F5F5"
        borderRadius="5px"
        boxShadow="24"
        p="25px"
      >
        <div className={styles.modal_content}>
          <div className={`${styles.modal_header} mb-0`}>
            <h5
              style={{
                fontSize: '19px',
                fontWeight: '700',
              }}
            >
              Delete Voucher
            </h5>
            <span onClick={() => setDeleteConfirmModalOpen(false)} style={{ cursor: 'pointer' }}>
              <img src="/assets/icons/x.svg" alt="" />
            </span>
          </div>
          <p className="text-muted mt-3">
            Are you sure you want to delete this voucher? This action cannot be undone.
          </p>
          <p className="font-weight-bold">
            Voucher Code: {selectedVoucher?.code}
          </p>
          <div className="d-flex justify-content-end mt-4" style={{ gap: '16px' }}>
            <button
              type="button"
              className="btn btn-outline-secondary"
              onClick={() => setDeleteConfirmModalOpen(false)}
              disabled={deleteVoucherLoading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={handleDeleteVoucher}
              disabled={deleteVoucherLoading}
            >
              {deleteVoucherLoading ? (
                <>
                  <CircularProgress size={20} style={{ color: 'white', marginRight: 8 }} />
                  Deleting...
                </>
              ) : (
                'Delete Voucher'
              )}
            </button>
          </div>
        </div>
      </GlobalModal>
      </>
    );
}
